export default interface IStep {
    label: string;
    labelText: string;
    overage: string;
    textColor: string;
    fillColor: string;
    badgeColor: string;
    status: number;
    isComplete: boolean;
}